const component = () => {
  return import(
    /* webpackChunkName: "Map" */
    "@/views/map/Map.vue"
  );
};

export default component;
